if (!customElements.get('trust-badges')) {
  class TrustBadges extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-tb-list]');
      this.dots = Array.from(this.querySelectorAll('[data-tb-dot]'));
      this.items = Array.from(this.querySelectorAll('.tb-item'));
      if (!this.list || this.dots.length === 0) return;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.scrollToIndex(parseInt(dot.dataset.index, 10)));
      });

      this.list.addEventListener('scroll', () => this.syncDots(), { passive: true });
      window.addEventListener('resize', () => this.syncDots());
      requestAnimationFrame(() => this.syncDots());
    }

    scrollToIndex(idx) {
      const item = this.items[idx];
      if (!item) return;
      const itemRect = item.getBoundingClientRect();
      const listRect = this.list.getBoundingClientRect();
      const offset = itemRect.left - listRect.left + this.list.scrollLeft;
      this.list.scrollTo({ left: offset, behavior: 'smooth' });
    }

    syncDots() {
      if (!this.list || this.items.length === 0) return;
      const listCenter = this.list.scrollLeft + this.list.clientWidth / 2;
      let closestIdx = 0;
      let closestDist = Infinity;
      this.items.forEach((item, i) => {
        const itemCenter = item.offsetLeft + item.clientWidth / 2;
        const dist = Math.abs(itemCenter - listCenter);
        if (dist < closestDist) {
          closestDist = dist;
          closestIdx = i;
        }
      });
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === closestIdx));
    }
  }
  customElements.define('trust-badges', TrustBadges);
}
